module.exports = __webpack_public_path__ + "e402ce768af7fd5a6bac1e209d34a992.svg";